// src/pages/TableCitoyens.jsx
import React from "react";
import Layout from "../components/Layout";
import AdminReunion from "../components/Admin/AdminReunion";

function AdminReunions() {
  
  return (
    <Layout >
      <div className="p-6">
        <AdminReunion />
      </div>
    </Layout>
  );
}

export default AdminReunions;
